"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccupationNodeSchema = exports.OccupationSchema = exports.OccupationI18nSchema = void 0;
/* eslint-disable perfectionist/sort-objects */
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.OccupationI18nSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    occupationId: zod_1.z.string(),
    locale: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.OccupationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    parentId: zod_1.z.string().nullable(),
    code: zod_1.z.string(),
    order: zod_1.z.number().int().nullable(),
});
exports.OccupationNodeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    code: zod_1.z.string(),
    order: zod_1.z.number().int().nullable(),
    localized: shared_1.LocalizedFieldSchema,
    children: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        code: zod_1.z.string(),
        order: zod_1.z.number().int().nullable(),
        localized: shared_1.LocalizedFieldSchema,
        children: zod_1.z.object({
            id: zod_1.z.string().uuid(),
            code: zod_1.z.string(),
            order: zod_1.z.number().int().nullable(),
            localized: shared_1.LocalizedFieldSchema,
        }),
    }),
});
